import React from 'react';

import SessaoDigitacaoBase from '../../components/Digitacao/SessaoDigitacaoBase';
import { MODOS_SESSAO } from '../../components/Digitacao/PainelSessaoDigitacao';

const SessaoRevisar = () => <SessaoDigitacaoBase mode={MODOS_SESSAO.REVISAR} />;

export default SessaoRevisar;
